module.exports = __webpack_public_path__ + "img/popup-icon.e4f71c68.svg";